import {
  EllipsisOutlined,
  PlusOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { useLocation, useNavigate } from "react-router";
import SelectProduct from "../../../components/SelectProduct";
import SelectOwner from "../../../components/SelectOwner";
import SelectPallet from "../../../components/SelectPallet";
import SelectOperator from "../../../components/SelectOperator";
import dayjs from "dayjs";
import API from "../../../services/api-request";
import { useEffect, useState } from "react";
import ItemPrint from "../../../components/print/print_item";
import Process from "./process";
import SelectLayoutNew from "../../../components/select-layout/SelectLayoutNew";
import { getDataLogin } from "../../../utils/getDataLogin";
import SelectMaterialHandling from "../../../components/SelectMaterialHandling";
import { baseUrl } from "../../../config/url-config";
import UserManualButton from "../../../components/UserManualButton";

const AddInbound = () => {
  const [loading, setLoading] = useState(false);
  const [selectionIndex, setSelectionIndex] = useState(0);
  const [selectedArea, setSelectedArea] = useState({});
  const navigate = useNavigate();
  const [addForm] = Form.useForm();

  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [openProcess, setOpenProcess] = useState(false);

  const [isCustomMaterialHandling, setIsCustomMaterialHandling] =
    useState(false);
  const [materialHandlingChecked, setMaterialHandlingChecked] = useState(false);

  const [draftData, setDraftData] = useState([]);
  const [confirmDraft, setConfirmDraft] = useState(false);
  const [confirmDraftLoading, setConfirmDraftLoading] = useState(false);

  const [selectedPallet, setSelectedPallet] = useState(null);

  const [confirmInbound, setConfirmInbound] = useState(false);

  const location = useLocation();
  const stateData = location?.state?.data || {};

  const today = dayjs().startOf("day");
  const isManagement =
    getDataLogin()?.privilege?.name?.toLowerCase() === "management";

  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const getDraftDetail = async (id) => {
    try {
      const response = await API.Get(`transaction/inbound/detail/${id}`);
      const data = response?.data || {};

      return data;
    } catch (err) {
      console.log(err);
      message.info(`${err?.response?.data?.error}`);
    }
  };

  const handleOk = (value) => {
    addForm.setFieldValue(["products", selectionIndex, "area_id"], value.id);
    addForm.setFieldValue(["products", selectionIndex, "area"], value.name);
    addForm.setFieldValue(["products", selectionIndex, "level"], value.level);
    addForm.setFieldValue(
      ["products", selectionIndex, "warehouse"],
      value.warehouse_name,
    );

    setOpen(false);
    setSelectedArea({});
  };

  const showModalProcess = () => {
    setOpenProcess(true);
  };

  const handleCancelProcess = () => {
    setOpenProcess(false);
  };

  const handleOkProcess = (data) => {
    if (data.pallet.id) {
      onSelectedPallet(data.pallet.id, data.pallet);
      addForm.setFieldValue(
        ["products", selectionIndex, "pallet_id"],
        data.pallet.id,
      );
    }

    if (data.operator.id) {
      addForm.setFieldValue(
        ["products", selectionIndex, "operator_id"],
        data.operator.id,
      );
    }

    if (data.weight.weight > 0) {
      addForm.setFieldValue(
        ["products", selectionIndex, "weight"],
        data.weight.weight,
      );
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const {
        code,
        client_id,
        schedule_at,
        products,
        note,
        material_handling_fee_type,
        material_handling_fee_cost,
      } = values;

      let dataForm = {
        transaction_id: draftData.transaction_id || null,
        code,
        client_id,
        schedule_at: dayjs(schedule_at).format("YYYY-MM-DD"),
        products: products.map((e) => {
          return {
            area_id: e.area_id,
            pallet_id: e.pallet_id,
            operator_id: e.operator_id,
            product_id: e.product_id,
            qty: e.qty ?? 0,
            specification: e.specification ?? "",
            weight: parseFloat(
              e.weight -
                (e.pallet_type === "kayu"
                  ? +e.pallet_weight + 10
                  : e.pallet_weight),
            ),
            pallet_weight:
              e.pallet_type === "kayu"
                ? +e.pallet_weight + 10
                : +e.pallet_weight,
          };
        }),
        note,
        material_handling_fee_cost: material_handling_fee_cost ?? 0,
      };

      const validAreaPalletMapping = isValidAreaPalletMapping(
        dataForm.products,
      );

      if (!validAreaPalletMapping) {
        message.warning(
          `Terdapat area duplikat dengan pallet berbeda, silahkan cek kembali.`,
        );
        return;
      }

      if (addForm.getFieldValue("material_handling_fee_type")) {
        dataForm.material_handling_fee_type = material_handling_fee_type;
      }

      if (dataForm.products.length < 1) {
        message.info("Belum scan RFID");
      } else {
        await API.Post("transaction/inbound/direct", dataForm);
        message.success("Inbound has been added");
        addForm.resetFields();
        handleBack();
      }
    } catch (err) {
      console.log(err);
      message.info(`${err?.response?.data?.error}`);
    } finally {
      setLoading(false);
      setConfirmInbound(false);
    }
  };

  const saveDraft = async () => {
    setConfirmDraftLoading(true);

    try {
      const {
        code,
        client_id,
        schedule_at,
        products,
        note,
        material_handling_fee_type,
        material_handling_fee_cost,
        transaction_id,
      } = draftData;

      const missingPallet = products.find((e) => !e.pallet_id);
      if (missingPallet) {
        message.warning("Pallet wajib diisi.");
        setConfirmDraftLoading(false);
        return;
      }

      if (!client_id) {
        message.warning("Nama pemilik wajib diisi.");
        setConfirmDraftLoading(false);
        return;
      }

      let dataForm = {
        status: "draft",
        transaction_id,
        code,
        client_id,
        schedule_at: dayjs(schedule_at).format("YYYY-MM-DD"),
        products: products.map((e) => {
          return {
            area_id: e.area_id,
            pallet_id: e.pallet_id,
            operator_id: e.operator_id,
            product_id: e.product_id,
            qty: e.qty,
            specification: e.specification,
            weight: e.weight,
            pallet_weight: e.pallet_weight,
          };
        }),
        note,
        material_handling_fee_cost: material_handling_fee_cost ?? 0,
      };

      const validAreaPalletMapping = isValidAreaPalletMapping(
        dataForm.products,
      );

      if (!validAreaPalletMapping) {
        message.warning(
          `Terdapat area duplikat dengan pallet berbeda, silahkan cek kembali.`,
        );
        return;
      }

      if (addForm.getFieldValue("material_handling_fee_type")) {
        dataForm.material_handling_fee_type = material_handling_fee_type;
      }

      await API.Post("transaction/inbound/direct", dataForm);
      message.success("Inbound has been added as draft");
      addForm.resetFields();
      handleBack();
    } catch (err) {
      console.log(err);
      message.info(`${err?.response?.data?.error}`);
    } finally {
      setConfirmDraftLoading(false);
      setConfirmDraft(false);
    }
  };

  const onFinishFailed = async (errorInfo) => {
    setConfirmInbound(false);
    console.log("Failed:", errorInfo);

    if (errorInfo?.errorFields?.length > 0) {
      setDraftData((prev) => ({ ...prev, ...errorInfo?.values }));
      setConfirmDraft(true);
    }
  };

  const handleBack = () => {
    navigate("/inbound");
  };

  const items = (index, remove) => [
    // {
    //   label: "Proses",
    //   onClick: () => {
    //     setSelectionIndex(index);
    //     showModalProcess();
    //   },
    // },
    {
      label: "Print",
      onClick: () => {
        handlePrint(index);
      },
    },
    {
      label: "Print from Android",
      onClick: () => {
        handlePrint(index, true);
      },
    },
    {
      label: "Delete",
      onClick: () => remove(index),
    },
  ];

  const handlePrint = async (index = null, thermer = false) => {
    const allProducts = addForm.getFieldValue("products") || [];
    const scheduleAt = addForm.getFieldValue("schedule_at") || null;
    const palletName = selectedPallet?.label;

    const productsToPrint = index !== null ? [allProducts[index]] : allProducts;

    const validProducts = productsToPrint
      .filter((product) => product?.area_id)
      .map((product) => ({
        ...product,
        scheduleAt: scheduleAt,
      }));

    if (validProducts.length === 0) {
      return message.info(
        index !== null
          ? "Data di baris ini belum lengkap untuk dicetak."
          : "Tidak ada data yang bisa dicetak.",
      );
    }

    if (thermer) {
      let url = "area/response";

      if (thermer) {
        const params = new URLSearchParams();

        if (validProducts?.[0]?.warehouse) {
          params.append("warehouseName", validProducts?.[0]?.warehouse);
        }
        if (validProducts?.[0]?.area) {
          params.append("areaName", validProducts?.[0]?.area);
        }
        if (scheduleAt) {
          params.append("tanggal", dayjs(scheduleAt).format("DD-MM-YYYY"));
        }
        if (palletName) {
          params.append("palletNo", palletName);
        }

        const queryString = params.toString();
        if (queryString) {
          url += `?${queryString}`;
        }
      }

      window.open(
        `my.bluetoothprint.scheme://${baseUrl + "/" + url}`,
        "_blank",
      );

      return;
    }

    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(ItemPrint(validProducts));

    setTimeout(function () {
      printWindow.document.close();
    }, 2000);

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print({ showPrintDialog: true });

      printWindow.onafterprint = () => {
        printWindow.close();
      };
    };
  };

  const onSelectedPallet = (value, options, index) => {
    if (value) {
      setSelectedPallet(options);

      addForm.setFieldValue(["products", index, "pallet_name"], options?.label);

      addForm.setFieldValue(["products", index, "pallet_weight"], "");
      if (!options?.type) return;
      addForm.setFieldValue(["products", index, "pallet_type"], options?.type);

      if (options.type === "besi") {
        addForm.setFieldValue(["products", index, "pallet_weight"], 85);
      }
    }
  };

  const onSelectedMaterialHandling = (value, options) => {
    addForm.setFieldValue("material_handling_fee_type", value);
    addForm.setFieldValue("material_handling_fee_cost", options?.cost);
    setIsCustomMaterialHandling(value === "custom");
  };

  const setInitialValues = () => {
    if (stateData.id) {
      getDraftDetail(stateData.id).then((data) => {
        if (data.transaction_details?.length < 1) {
          addForm.setFieldValue("products", [{}]);
        } else {
          setDraftData((prev) => ({
            ...prev,
            transaction_id: data?.id,
            status: data?.status,
          }));

          addForm.setFieldsValue({
            code: data?.code,
            client_id: data?.client_id,
            schedule_at: dayjs(data?.schedule_at),
            products: data?.transaction_details?.map((e) => {
              return {
                area: e?.transaction_detail_pallets?.[0]?.area?.name,
                area_id: e?.transaction_detail_pallets?.[0]?.area_id,
                pallet_id: e?.transaction_detail_pallets?.[0]?.pallet_id,
                operator_id: e?.transaction_detail_pallets?.[0]?.operator_id,
                product_id: e?.product_id,
                qty:
                  typeof e?.estimate_qty === "undefined" ? 0 : e?.estimate_qty,
                specification: e.estimate_specification,
                weight: parseFloat(e.estimate_weight),
                pallet_weight:
                  e?.transaction_detail_pallets?.[0]?.pallet_weight,
              };
            }),
            note: data?.note,
            material_handling_fee_type:
              data?.material_handling_fee_type || null,
            material_handling_fee_cost:
              data?.material_handling_fee_cost || null,
          });
        }

        if (data?.material_handling_fee_type) {
          setMaterialHandlingChecked(true);
        }
      });
    }
  };

  function isValidAreaPalletMapping(products) {
    const areaToPallet = new Map();
    const palletToArea = new Map();

    for (const p of products) {
      const { area_id, pallet_id } = p;

      const existingPallet = areaToPallet.get(area_id);
      const existingArea = palletToArea.get(pallet_id);

      // First time seeing this area
      if (!existingPallet && !existingArea) {
        areaToPallet.set(area_id, pallet_id);
        palletToArea.set(pallet_id, area_id);
        continue;
      }

      // Check consistency: both directions must match the first combo
      if (existingPallet !== undefined && existingPallet !== pallet_id) {
        return false; // same area, different pallet
      }

      if (existingArea !== undefined && existingArea !== area_id) {
        return false; // same pallet, different area
      }
    }

    return true;
  }

  useEffect(() => {
    addForm.setFieldValue("schedule_at", dayjs());
    setInitialValues();
  }, []);

  return (
    <>
      <Form
        form={addForm}
        name="Add Form"
        style={{
          margin: "0 auto",
        }}
        layout="vertical"
        autoComplete="off"
        initialValues={{
          products: [{}], // Memberikan default 1 item kosong
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row justify={"space-between"} align={"middle"}>
          <Col lg={12} md={12} sm={12} xs={24}>
            <h2>New Inbound</h2>
          </Col>
          <Col lg={6} md={6} sm={6} xs={24}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "1rem",
              }}
            >
              <Button
                type="primary"
                icon={<PrinterOutlined />}
                style={{
                  backgroundColor: "#4caf50",
                  color: "#fff",
                  borderColor: "#4caf50",
                  width: "100%",
                }}
                onClick={() => handlePrint()}
              >
                Print All
              </Button>

              <UserManualButton />
            </div>
          </Col>
        </Row>
        <hr />
        <br />
        <Row gutter={[8, 8]}>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item label="Kode" name="code">
              <Input placeholder="Masukan Kode" />
            </Form.Item>
          </Col>
          <Col lg={6} md={6} sm={6} xs={24}>
            <Form.Item
              label={
                <span>
                  <Checkbox
                    checked={materialHandlingChecked}
                    onChange={() => {
                      setMaterialHandlingChecked(!materialHandlingChecked);
                      addForm.setFieldValue("material_handling_fee_type", null);
                      addForm.setFieldValue("material_handling_fee_cost", null);
                      setIsCustomMaterialHandling(false);
                    }}
                  />{" "}
                  Material Handling
                </span>
              }
              name="material_handling_fee_type"
            >
              <SelectMaterialHandling
                onChange={onSelectedMaterialHandling}
                disabled={!materialHandlingChecked}
              />
            </Form.Item>
          </Col>
          <Col lg={6} md={6} sm={6} xs={24}>
            <Form.Item
              label="Material Handling Fee per kg"
              name="material_handling_fee_cost"
            >
              <InputNumber
                placeholder="Material Handling Fee"
                prefix="Rp"
                min={0}
                controls={false}
                style={{
                  width: "100%",
                }}
                disabled={!materialHandlingChecked}
                readOnly={!isCustomMaterialHandling}
              />
            </Form.Item>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item
              label="Nama Pemilik"
              name="client_id"
              rules={[
                {
                  required: true,
                  message: "Please input your Nama Pemilik!",
                },
              ]}
            >
              <SelectOwner />
            </Form.Item>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item
              label="Tanggal Masuk"
              name="schedule_at"
              rules={[
                {
                  required: true,
                  message: "Please input your Tanggal Masuk!",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format="YYYY-MM-DD"
                placeholder="Pilih Tanggal"
                disabledDate={(current) => {
                  if (!isManagement) {
                    return !current || !current.isSame(today, "day");
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <Form.Item label="Silahkan Scan RFID">
              <Form.List name="products">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map((field, index) => (
                      <Row key={field.key} gutter={[4, 4]} align="top">
                        {/* Pallet */}
                        <Col span={3}>
                          <Form.Item
                            {...field}
                            name={[field.name, "pallet_id"]}
                            fieldKey={[field.fieldKey, "pallet_id"]}
                            rules={[
                              {
                                required: true,
                                message: "Please input pallet!",
                              },
                            ]}
                          >
                            <SelectPallet
                              allowUsed={false}
                              onChange={(value, options) => {
                                onSelectedPallet(value, options, index);
                              }}
                            />
                          </Form.Item>
                        </Col>
                        {/* Pallet Weight*/}
                        <Col span={2}>
                          <Form.Item
                            {...field}
                            name={[field.name, "pallet_weight"]}
                            fieldKey={[field.fieldKey, "pallet_weight"]}
                            rules={[
                              {
                                required: true,
                                message: "Please input pallet weight!",
                              },
                            ]}
                          >
                            <InputNumber
                              min={0}
                              placeholder="Pallet Weight"
                              readOnly={
                                addForm.getFieldValue([
                                  "products",
                                  index,
                                  "pallet_type",
                                ]) === "besi"
                              }
                              suffix={"Kg"}
                              controls={false}
                              style={{ width: "100%" }}
                              step={"0.1"}
                            />
                          </Form.Item>
                        </Col>

                        {/* Operator */}
                        <Col span={3}>
                          <Form.Item
                            {...field}
                            name={[field.name, "operator_id"]}
                            fieldKey={[field.fieldKey, "operator_id"]}
                            rules={[
                              {
                                required: true,
                                message: "Please input jenis operator!",
                              },
                            ]}
                          >
                            <SelectOperator />
                          </Form.Item>
                        </Col>

                        {/* Jenis Produk */}
                        <Col span={4}>
                          <Form.Item
                            {...field}
                            name={[field.name, "product_id"]}
                            fieldKey={[field.fieldKey, "product_id"]}
                            rules={[
                              {
                                required: true,
                                message: "Please input jenis produk!",
                              },
                            ]}
                          >
                            <SelectProduct />
                          </Form.Item>
                        </Col>

                        {/* Spesifikasi */}
                        <Col span={3}>
                          <Form.Item
                            {...field}
                            name={[field.name, "specification"]}
                            fieldKey={[field.fieldKey, "specification"]}
                          >
                            <Input placeholder="Spesifikasi" />
                          </Form.Item>
                        </Col>

                        {/* Berat */}
                        <Col span={2}>
                          <Form.Item
                            {...field}
                            name={[field.name, "weight"]}
                            fieldKey={[field.fieldKey, "weight"]}
                            rules={[
                              {
                                required: true,
                                message: "Please input berat!",
                              },
                            ]}
                          >
                            <InputNumber
                              min={0}
                              placeholder="Berat"
                              suffix={"Kg"}
                              controls={false}
                              style={{ width: "100%" }}
                              step={"0.1"}
                            />
                          </Form.Item>
                        </Col>
                        {/*Jumlah Pack */}
                        <Col span={2}>
                          <Form.Item
                            {...field}
                            name={[field.name, "qty"]}
                            fieldKey={[field.fieldKey, "qty"]}
                          >
                            <InputNumber
                              min={0}
                              placeholder="Jumlah Pack"
                              controls={false}
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </Col>

                        {/* Area */}
                        <Col span={3}>
                          <Form.Item
                            {...field}
                            name={[field.name, "area"]}
                            fieldKey={[field.fieldKey, "area"]}
                            rules={[
                              {
                                required: true,
                                message: "Please input area!",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Pilih Area"
                              readOnly
                              onClick={() => {
                                showModal();
                                setSelectionIndex(index);
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col
                          span={1}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Form.Item>
                            <Dropdown
                              menu={{ items: items(index, remove) }}
                              trigger={["click"]}
                            >
                              <EllipsisOutlined />
                            </Dropdown>
                          </Form.Item>
                        </Col>

                        <Col span={1}>
                          <Button
                            type="primary"
                            style={{
                              backgroundColor: "#4caf50",
                              color: "#fff",
                              borderColor: "#4caf50",
                              width: "100%",
                            }}
                            onClick={() => {
                              setSelectionIndex(index);
                              showModalProcess();
                            }}
                          >
                            Process
                          </Button>
                        </Col>
                      </Row>
                    ))}
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      style={{ width: "100%" }}
                    >
                      Tambah Baris
                    </Button>
                  </>
                )}
              </Form.List>
            </Form.Item>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Button
              style={{
                width: "100%",
                backgroundColor: "orange",
                borderColor: "orange",
                color: "white",
              }}
              type="primary"
              onClick={() => handleBack()}
            >
              Kembali
            </Button>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Button
              onClick={() => {
                setConfirmInbound(true);
              }}
              style={buttonStyle}
              type="primary"
              loading={loading}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
      <Modal
        title="Silahkan Pilih Rak"
        okText="Ok"
        cancelText="Tutup"
        open={open}
        onOk={saveDraft}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        okType={"primary"}
        width="80%"
        height="80%"
        footer={null}
      >
        <SelectLayoutNew
          value={selectedArea?.id}
          onChange={(value) => {
            handleOk(value);

            setSelectedArea(value);
          }}
        />
      </Modal>
      <Modal
        title="Simpan sebagai Draft"
        okText="Ok"
        cancelText="Tutup"
        open={confirmDraft}
        onOk={saveDraft}
        confirmLoading={confirmDraftLoading}
        onCancel={() => setConfirmDraft(false)}
        okType={"primary"}
      >
        <p>Data belum lengkap. Simpan sebagai draft?</p>
      </Modal>

      <Modal
        title="Konfirmasi Inbound"
        okText="Ok"
        cancelText="Tutup"
        open={confirmInbound}
        onOk={() => addForm.submit()}
        confirmLoading={loading}
        onCancel={() => setConfirmInbound(false)}
        okType={"primary"}
      >
        <p>Anda akan menyimpan inbound. Apakah data yang diisi sudah sesuai?</p>
        <p style={{ color: "red" }}>Data yang tersimpan tidak dapat diubah.</p>
      </Modal>

      <Process
        openProcess={openProcess}
        setOpenProcess={handleCancelProcess}
        handleOkProcess={handleOkProcess}
        onSelectedPallet={onSelectedPallet}
        selectionIndex={selectionIndex}
      />
    </>
  );
};

const buttonStyle = {
  width: "100%",
};

export default AddInbound;
